export default __webpack_public_path__ + "static/media/error-circle.f7099379.svg";